module.exports = __webpack_public_path__ + "static/media/11.aa83af72.jpg";